<template>
    <div :class="classes">
        <div :class="theme.alertIcon">
            <v-font-icon :class="theme.icon">
                {{ icon }}
            </v-font-icon>
        </div>
        <div :class="theme.alertContent">
            <slot></slot>
        </div>
    </div>
</template>
<script>
import { vFontIcon } from '../FontIcon';
import theme from './alert.scss';

export default {
    name: 'alert',
    props: {
        success: Boolean,
        info: Boolean,
        danger: Boolean,
        icon: {
            type: String,
            default: 'info'
        },
        theme: {
            type: Object,
            default() {
                return theme;
            }
        }
    },
    components: {
        vFontIcon,
    },
    computed: {
        classes() {
            return {
                [this.theme.alert]: true,
                [this.theme.isInfo]: this.info,
                [this.theme.isSuccess]: this.success,
                [this.theme.isDanger]: this.danger,
            }
        },
    }
}
</script>


// WEBPACK FOOTER //
// Alert.vue?69994a58